/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CreateBookingGuestRegistrationPayload } from 'api/actions/create-booking-guest-registration/create-booking-guest-registration-payload';
import { CreateBookingGuestRegistrationPathParameters } from 'api/actions/create-booking-guest-registration/create-booking-guest-registration-path-parameters';
import { CreateBookingGuestRegistrationResponse } from 'api/actions/create-booking-guest-registration/create-booking-guest-registration-response';

type CreateBookingGuestRegistrationQueryParameters = Record<string, any>;

/**
 * The path of the CreateBookingGuestRegistration action.
 */
export const createBookingGuestRegistrationActionPath = new SweetPath<
  keyof CreateBookingGuestRegistrationPathParameters
>('/reservations/public/spaces/{slug}/registrations', { path: '{param}' });

/**
 * Creates a contextualized CreateBookingGuestRegistration actions.
 */
export default function createCreateBookingGuestRegistrationAction(axios: AxiosInstance) {
  return function createBookingGuestRegistrationAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: CreateBookingGuestRegistrationPathParameters;
    query?: CreateBookingGuestRegistrationQueryParameters;
    payload: CreateBookingGuestRegistrationPayload;
  }) {
    const path = createBookingGuestRegistrationActionPath.insert(parameters);

    return axios.post<
      CreateBookingGuestRegistrationResponse,
      CreateBookingGuestRegistrationResponse,
      CreateBookingGuestRegistrationPayload
    >(path, payload);
  };
}
